import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const AddressLines = ({ line1, line2 }) => (
  <Fragment>
    {line1}
    {line2 ? (
      <Fragment>
        <br />
        {line2}
      </Fragment>
    ) : null}
  </Fragment>
);

AddressLines.propTypes = {
  line1: PropTypes.string,
  line2: PropTypes.string
};

AddressLines.defaultProps = {
  line1: '',
  line2: ''
};

export default AddressLines;
